import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button, Col, Space, Form } from 'antd'
import {
  getHeaders,
  usersUrl,
  successNotification,
  errorNotification
} from '../../config'
import BasicInput from 'components/Forms/BasicInput'
import SelectInput from 'components/Forms/SelectInput'
import PropTypes from 'prop-types'
import { ADMIN, MANAGER, DELIVERY_GUY } from 'app-constants'

const Update = props => {
  const [user, setUser] = useState({
    email: props.user.email,
    firstName: props.user.firstName,
    lastName: props.user.lastName,
    phoneNumber: props.user.phoneNumber,
    jobTitle: props.user.jobTitle,
    userType: props.user.userType,
    branches: props.user.branches.map(ow => ow.id)
  })

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const getUser = () => {
    setUser(props.user)
  }

  useEffect(() => {
    getUser()
    // eslint-disable-next-line
  }, [])

  const handleInputChange = stateName => event => {
    setUser({ ...user, [stateName]: event.target.value })
  }

  // const handleDateUpdate = stateName => date => {
  //   setUser({ ...user, [stateName]: date })
  // }

  const handleSelect = stateName => value => {
    setUser({
      ...user,
      [stateName]: value
    })
  }

  const handleSubmit = event => {
    event.preventDefault()

    setLoading(true)
    axios
      .post(usersUrl + '/' + user.id + '/update-user', user, {
        headers: getHeaders()
      })
      .then(() => {
        setLoading(false)
        props.handleCancel()
        successNotification('User Updated')
      })
      .catch(err => {
        setLoading(false)
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error updating user, retry.')
      })
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form layout="vertical" className="p-2rem">
            <div className="row">
              <div className="col-md-5">
                <BasicInput
                  label="First Name"
                  value={user.firstName}
                  name={'first name'}
                  placeholder="first name"
                  handleChange={handleInputChange('firstName')}
                  required={true}
                />
                {serverErrors.firstName &&
                  serverErrors.firstName.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Last Name"
                  value={user.lastName}
                  name={'last name'}
                  placeholder="last name"
                  handleChange={handleInputChange('lastName')}
                  required={true}
                />
                {serverErrors.lastName &&
                  serverErrors.lastName.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Phone Number"
                  value={user.phoneNumber}
                  name={'phone number'}
                  placeholder="phone number"
                  handleChange={handleInputChange('phoneNumber')}
                  required={true}
                />

                {serverErrors.phoneNumber &&
                  serverErrors.phoneNumber.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Email"
                  value={user.email}
                  name={'email'}
                  placeholder="email"
                  handleChange={handleInputChange('email')}
                  required={false}
                />
                {serverErrors.email &&
                  serverErrors.email.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Job Title"
                  value={user.jobTitle}
                  name={'job title'}
                  placeholder="job title"
                  handleChange={handleInputChange('jobTitle')}
                  required={true}
                />
                {serverErrors.jobTitle &&
                  serverErrors.jobTitle.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Choose This User Type"
                  name="user type"
                  value={user.userType}
                  onChange={handleSelect('userType')}
                  optionList={[
                    { label: 'Admin', value: ADMIN },
                    { label: 'Manager', value: MANAGER },
                    { label: 'Delivery Guy', value: DELIVERY_GUY }
                  ]}
                  required={true}
                />
                {serverErrors.userType &&
                  serverErrors.userType.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    <Button onClick={() => props.handleCancel()}>Close</Button>
                    <Button
                      type="primary"
                      onClick={handleSubmit}
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

Update.propTypes = {
  user: PropTypes.object,
  handleCancel: PropTypes.func
}

export default Update
